import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "./api";

const SESSION_KEY = "tc_session_id";

function getSessionId() {
  if (typeof window === "undefined") return "";
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s =
        (window.crypto?.randomUUID?.() ||
          Math.random().toString(36).slice(2) + Date.now().toString(36)).slice(0, 32);
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return "";
  }
}

function getUtm(params) {
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
  };
}

/**
 * Logs an SPA pageview to /api/track/pageview on every route change.
 * Uses sendBeacon when available (fire-and-forget, doesn't delay nav).
 * Falls back to fetch with keepalive. Silently no-ops on /admin paths
 * (backend filters them too as defence-in-depth).
 */
export default function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path.startsWith("/admin")) return;

    const params = new URLSearchParams(location.search || "");
    const payload = {
      path,
      referrer: typeof document !== "undefined" ? document.referrer : "",
      ...getUtm(params),
      session_id: getSessionId(),
      viewport:
        typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : "",
    };

    const url = `${API}/track/pageview`;
    const body = JSON.stringify(payload);
    try {
      // We don't use cookies — omit credentials so we never hit the
      // wildcard-CORS preflight issue. Avoid sendBeacon because it always
      // sends credentials and can't have its Origin policy controlled.
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
        credentials: "omit",
        mode: "cors",
      }).catch(() => {});
    } catch {
      /* never break user-facing pages over analytics */
    }
  }, [location.pathname, location.search]);
}
